import { EditorAppContext } from '../types';
import { getSearchAppControllers } from '../searchAppController';
import {
  getControllerConnectedComponents,
  removeComponents,
  removeController,
} from '../editorSDKHelpers';
import { isSearchBox } from '../searchBox';
import { addSearchButton } from '../searchButton';

export const replaceSearchBoxToSearchButton = async ({
  appContext,
}: {
  appContext: EditorAppContext;
}) => {
  const { editorSDK, appDefinitionId } = appContext;
  try {
    return await editorSDK.document.transactions.runAndWaitForApproval(
      appDefinitionId,
      async () => {
        const currentSearchBoxControllers = await getSearchAppControllers(
          appContext,
        );

        for (const controllerRef of currentSearchBoxControllers) {
          const connectedComponentsRefs =
            await getControllerConnectedComponents(appContext, controllerRef);

          for (const componentRef of connectedComponentsRefs) {
            if (await isSearchBox(appContext, componentRef)) {
              const parentRef = (
                await editorSDK.components.getAncestors(appDefinitionId, {
                  componentRef: controllerRef,
                })
              )[0];

              const controllerLayout = await editorSDK.components.layout.get(
                appDefinitionId,
                { componentRef: controllerRef },
              );
              const searchBoxStyleProps = await editorSDK.components.style.get(
                appDefinitionId,
                {
                  componentRef,
                },
              );

              await addSearchButton(appContext, {
                pageRef: parentRef,
                styleProps: {
                  color: {
                    value: String(
                      searchBoxStyleProps.style.properties.inputBorderColor ??
                        '',
                    ),
                    src: searchBoxStyleProps.style.propertiesSource
                      .inputBorderColor,
                  },
                  hoverColor: {
                    value: String(
                      searchBoxStyleProps.style.properties
                        .inputHoverBorderColor ?? '',
                    ),
                    src: searchBoxStyleProps.style.propertiesSource
                      .inputHoverBorderColor,
                  },
                },
                layoutProps: {
                  layout: {
                    ...controllerLayout,
                    width: controllerLayout.height,
                  },
                },
              });
            }
          }

          await removeController(appContext, controllerRef);
        }
      },
    );
  } catch (error) {
    reportError(error);
  }
};
